import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteTemplateDocument } from './delete.generated';

export const useDeleteTemplate = (options: ApiOptions<typeof DeleteTemplateDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(DeleteTemplateDocument, {
    ...useNotifications(DeleteTemplateDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.templates.delete_success'),
    }),

    // This was already there...I guess it's to invalidate the top-level query
    update(cache, { data }) {
      if (data?.deleteTemplate?.template == null) return;
      cache.evict({ id: cache.identify(data.deleteTemplate.template) });
    },

    ...options,
  });
};
